import React from 'react';
import PropTypes from 'prop-types';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { DELETE_MODAL, BUTTONS, SUCCESS, QUERY_KEYS } from '../../../constants';
import { popup, deleteScorecardByAccountAndPlatform, deleteScoreCardDetails } from '../../../utils';
import { CircleSpinner } from '../../../assets/svg';

const ScoreCardDeleteModal = ({
    isDeleteScorecardByAccountAndPlatform,
    isDeleteModal,
    setIsDeleteModal,
    selectedData,
    deleteButtonName,
}) => {
    const queryClient = useQueryClient();

    const deleteScorecardMutation = useMutation({
        mutationFn: async () =>
            await deleteScorecardByAccountAndPlatform({
                accountId: selectedData.account_id,
                platformId: selectedData.platform_id,
            }),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: [QUERY_KEYS.SCORECARD_LIST],
                exact: false,
            });
            popup('error', SUCCESS.SCORE_CARD_COLUMNS_ADMIN.DELETED);
            setIsDeleteModal(false);
        },
        onError: (error) => {
            popup('error', error.message);
        },
    });

    const deleteScorecardEntryMutation = useMutation({
        mutationFn: async () => await deleteScoreCardDetails({ id: selectedData.id }),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: [QUERY_KEYS.SCORECARD_DETAILS],
                exact: false,
            });
            popup('error', SUCCESS.SCORE_CARD_COLUMNS_ADMIN.DELETED);
            setIsDeleteModal(false);
        },
        onError: (error) => {
            popup('error', error.message);
        },
    });

    const handleDeleteClick = async () => {
        if (isDeleteScorecardByAccountAndPlatform) {
            deleteScorecardMutation.mutate();
        } else {
            deleteScorecardEntryMutation.mutate();
        }
    };

    return (
        <div
            className={`modal custom-modal-doc-cato fade ${isDeleteModal ? 'show' : ''}`}
            tabIndex={-1}
            aria-labelledby='exampleModalLabel'
            aria-hidden={!isDeleteModal}
            role='dialog'
            style={{ display: isDeleteModal ? 'block' : 'none' }}
        >
            <div className='modal-dialog w-100'>
                <div className='modal-content border-0'>
                    <div className='d-flex align-items-center justify-content-end'>
                        <button
                            type='button'
                            onClick={() => setIsDeleteModal(false)}
                            className='btn-close'
                        ></button>
                    </div>
                    <div className='modal-body p-0'>
                        <h3 className='text-center del-title mt-0'>
                            {`${DELETE_MODAL.DELETE_HEADING} ${deleteButtonName}?`}
                        </h3>
                        <p className='text-center dl-para'>
                            {DELETE_MODAL.PARA_TEXT}
                            <br />
                            {DELETE_MODAL.UNDO_TEXT}
                        </p>
                    </div>
                    <div className='d-flex align-items-center justify-content-center modal-btn'>
                        <button
                            type='button'
                            className='ssc-secondary-white-btn'
                            onClick={() => setIsDeleteModal(false)}
                            disabled={
                                deleteScorecardMutation.isPending ||
                                deleteScorecardEntryMutation.isPending
                            }
                        >
                            {BUTTONS.CANCEL_BUTTON}
                        </button>
                        <button
                            type='button'
                            className='ssc-primary-green-btn py-0 w-auto'
                            onClick={handleDeleteClick}
                            disabled={
                                deleteScorecardMutation.isPending ||
                                deleteScorecardEntryMutation.isPending
                            }
                        >
                            {(deleteScorecardMutation.isPending ||
                                deleteScorecardEntryMutation.isPending) && (
                                <span className='me-1'>
                                    <CircleSpinner />
                                </span>
                            )}
                            {DELETE_MODAL.DELETE_BUTTON}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ScoreCardDeleteModal;
ScoreCardDeleteModal.propTypes = {
    isDeleteModal: PropTypes.bool,
    setIsDeleteModal: PropTypes.func,
    selectedItemId: PropTypes.string,
    deleteButtonName: PropTypes.string,
};
